import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const ObstetricsGynaecologyIcon = React.memo(
  ({ width = 81, height = 80, viewBox = '0 0 81 80' }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      <path
        fill={variables['colors-mc-primary']}
        fillOpacity='0.1'
        stroke={variables['colors-mc-primary']}
        d='M79.9282 40C79.9282 61.8153 62.2435 79.5 40.4282 79.5C18.613 79.5 0.928223 61.8153 0.928223 40C0.928223 18.1848 18.613 0.5 40.4282 0.5C62.2435 0.5 79.9282 18.1848 79.9282 40Z'
      />
      <g clipPath='url(#clip0_414_8547)'>
        <path
          d='M64.9056 34.9802H47.8299C47.2534 34.9802 46.7861 35.4475 46.7861 36.024V42.7389L52.1682 52.0609C52.7037 52.9884 52.7037 54.0958 52.1682 55.0234C51.6327 55.9509 50.6735 56.5046 49.6026 56.5046V56.6039H60.9699C62.2854 56.6039 63.3517 55.5375 63.3517 54.2221V39.2478C63.3517 38.9387 63.4432 38.6366 63.6146 38.3793L65.3398 35.7915C65.571 35.4447 65.3224 34.9802 64.9056 34.9802Z'
          fill='#DFF6FD'
        />
        <path
          d='M64.9056 34.9802H61.7887C62.2055 34.9802 62.4541 35.4448 62.2229 35.7916L60.4977 38.3794C60.3262 38.6367 60.2348 38.9388 60.2348 39.2479V54.2222C60.2348 55.5375 59.1685 56.604 57.853 56.604H60.9699C62.2854 56.604 63.3517 55.5376 63.3517 54.2222V39.2478C63.3517 38.9387 63.4432 38.6366 63.6147 38.3793L65.3398 35.7915C65.571 35.4447 65.3224 34.9802 64.9056 34.9802Z'
          fill='#C8EFFE'
        />
        <path
          d='M50.4424 49.072L52.1681 52.0609C52.7036 52.9884 52.7036 54.0958 52.1681 55.0234C51.6326 55.9509 50.6734 56.5046 49.6025 56.5046V56.6039H60.9698C62.2853 56.6039 63.3516 55.5375 63.3516 54.2221V49.072H50.4424Z'
          fill='#FE2AA8'
        />
        <path
          d='M63.3517 54.2221V49.072H60.2348V54.2221C60.2348 55.5375 59.1685 56.6039 57.853 56.6039H60.9699C62.2853 56.6038 63.3517 55.5375 63.3517 54.2221Z'
          fill='#F1239A'
        />
        <path
          d='M58.94 39.4714H57.27C56.8654 39.4714 56.5376 39.1436 56.5376 38.739C56.5376 38.3344 56.8654 38.0066 57.27 38.0066H58.94C59.3446 38.0066 59.6725 38.3344 59.6725 38.739C59.6725 39.1436 59.3445 39.4714 58.94 39.4714Z'
          fill='white'
        />
        <path
          d='M58.94 42.9158H57.27C56.8654 42.9158 56.5376 42.5879 56.5376 42.1833C56.5376 41.7788 56.8654 41.4509 57.27 41.4509H58.94C59.3446 41.4509 59.6725 41.7788 59.6725 42.1833C59.6725 42.5879 59.3445 42.9158 58.94 42.9158Z'
          fill='white'
        />
        <path
          d='M58.94 46.3601H57.27C56.8654 46.3601 56.5376 46.0323 56.5376 45.6277C56.5376 45.2231 56.8654 44.8953 57.27 44.8953H58.94C59.3446 44.8953 59.6725 45.2231 59.6725 45.6277C59.6725 46.0323 59.3445 46.3601 58.94 46.3601Z'
          fill='white'
        />
        <path
          d='M58.94 49.8042H57.27C56.8654 49.8042 56.5376 49.4764 56.5376 49.0718C56.5376 48.6672 56.8654 48.3394 57.27 48.3394H58.94C59.3446 48.3394 59.6725 48.6672 59.6725 49.0718C59.6725 49.4764 59.3445 49.8042 58.94 49.8042Z'
          fill='white'
        />
        <path
          d='M58.94 53.2485H57.27C56.8654 53.2485 56.5376 52.9207 56.5376 52.5161C56.5376 52.1115 56.8654 51.7837 57.27 51.7837H58.94C59.3446 51.7837 59.6725 52.1115 59.6725 52.5161C59.6725 52.9207 59.3445 53.2485 58.94 53.2485Z'
          fill='white'
        />
        <path
          d='M35.8315 26.5274H36.1325V35.4348C36.1325 35.8928 36.012 36.3428 35.7829 36.7395L32.5835 42.281H46.6364L43.437 36.7395C43.208 36.3428 43.0874 35.8929 43.0874 35.4348V26.5274H43.3884C44.253 26.5274 44.954 25.8264 44.954 24.9618C44.954 24.0971 44.253 23.3962 43.3884 23.3962H35.8314C34.9668 23.3962 34.2658 24.0971 34.2658 24.9618C34.2658 25.8264 34.9669 26.5274 35.8315 26.5274Z'
          fill='#C8EFFE'
        />
        <path
          d='M43.5319 42.281H46.636L43.4366 36.7395C43.2076 36.3428 43.087 35.8929 43.087 35.4348V26.5274H43.3437C44.1867 26.5274 44.9121 25.8795 44.9518 25.0375C44.9941 24.1384 44.2777 23.3962 43.388 23.3962H40.2839C41.1736 23.3962 41.89 24.1384 41.8477 25.0375C41.808 25.8795 41.0826 26.5274 40.2396 26.5274C40.0979 26.5274 39.9829 26.6423 39.9829 26.7841V35.4347C39.9829 35.8927 40.1035 36.3427 40.3325 36.7394L43.5319 42.281Z'
          fill='#99E6FC'
        />
        <path
          d='M26.9655 52.0113C25.7871 54.0524 27.2602 56.6038 29.617 56.6038H49.6025C51.9594 56.6038 53.4324 54.0524 52.254 52.0113L46.5799 42.1833H32.6396L26.9655 52.0113Z'
          fill='#00F2A6'
        />
        <path
          d='M52.2538 52.0113L46.5797 42.1833H43.4756L49.1497 52.0113C50.3281 54.0524 48.8551 56.6038 46.4982 56.6038H49.6023C51.9593 56.6038 53.4322 54.0524 52.2538 52.0113Z'
          fill='#05E39C'
        />
        <path
          d='M16.1606 55.3493C16.1606 55.6375 16.3942 55.8712 16.6825 55.8712H38.274C38.5622 55.8712 38.7959 55.6376 38.7959 55.3493V53.1201H16.1606V55.3493Z'
          fill='#01D0FB'
        />
        <path
          d='M34.6483 53.1201V55.3493C34.6483 55.6375 34.4147 55.8712 34.1265 55.8712H38.2739C38.5621 55.8712 38.7958 55.6376 38.7958 55.3493V53.1201H34.6483Z'
          fill='#01C0FA'
        />
        <path
          d='M38.2739 56.6037H16.6825C15.9909 56.6037 15.4282 56.041 15.4282 55.3494V48.6793C15.4282 47.9877 15.9909 47.425 16.6825 47.425H38.2739C38.9656 47.425 39.5283 47.9877 39.5283 48.6793V55.3494C39.5283 56.041 38.9656 56.6037 38.2739 56.6037ZM16.8931 55.1388H38.0635V48.89H16.8931V55.1388Z'
          fill='#C8EFFE'
        />
        <path
          d='M21.8348 40.7231L25.0137 37.5442L22.9854 35.516C22.1112 34.6418 20.6808 34.6418 19.8065 35.516C18.9323 36.3902 18.9323 37.8207 19.8065 38.6949L21.8348 40.7231Z'
          fill='#E2DEE2'
        />
        <path
          d='M23.6995 38.8584L25.0137 37.5442L22.9854 35.516C22.1905 34.7211 20.9369 34.6515 20.0586 35.3023C20.2007 35.3908 20.3356 35.4946 20.4588 35.6177L23.6995 38.8584Z'
          fill='#CBC4CC'
        />
        <path
          d='M21.7656 40.654L23.7247 42.6131C24.5989 43.4873 26.0294 43.4873 26.9036 42.6131C27.7778 41.7389 27.7778 40.3084 26.9036 39.4342L24.9445 37.4751L21.7656 40.654Z'
          fill='#AF66DA'
        />
        <path
          d='M26.9036 39.4342L24.9445 37.4751L23.6304 38.7893L24.377 39.5358C25.2512 40.4101 25.2512 41.8405 24.377 42.7147C24.2977 42.794 24.2125 42.8636 24.1249 42.9284C24.9917 43.468 26.1525 43.3641 26.9036 42.613C27.7778 41.7389 27.7778 40.3083 26.9036 39.4342Z'
          fill='#9857BD'
        />
      </g>
      <defs>
        <clipPath id='clip0_414_8547'>
          <rect width='50' height='50' fill='white' transform='translate(15.4282 15)' />
        </clipPath>
      </defs>
    </svg>
  )
);
ObstetricsGynaecologyIcon.displayName = 'ObstetricsGynaecologyIcon';

export default ObstetricsGynaecologyIcon;
